import React from "react";
import styles from "../styles/ChatClassification.module.css";

export type MicButtonState = "idle" | "recording" | "transcribing" | "disabled";

interface Props {
  state: MicButtonState;
  supported: boolean;
  onClick: () => void;
}

const MicButton: React.FC<Props> = ({ state, supported, onClick }) => {
  if (!supported) return null;

  const isDisabled = state === "disabled" || state === "transcribing";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`${styles.micButton} ${state === "recording" ? styles.micButtonRecording : ""}`}
      aria-label={state === "recording" ? "Parar gravação" : "Gravar pergunta por voz"}
      title={state === "recording" ? "Parar gravação" : "Gravar pergunta por voz"}
    >
      {state === "transcribing" ? (
        <span className={styles.micTranscribingDot} />
      ) : (
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3z" />
          <path d="M17 11a1 1 0 1 0-2 0 3 3 0 0 1-6 0 1 1 0 1 0-2 0 5 5 0 0 0 4 4.9V18H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.1A5 5 0 0 0 17 11z" />
        </svg>
      )}
    </button>
  );
};

export default MicButton;
